export default "__VITE_ASSET__BcoYfoGi__"